import { QuestionnaireListPage } from './QuestionnaireListPage';
export default QuestionnaireListPage;